import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import { PerfectScrollbarComponent } from "ngx-perfect-scrollbar";
import pdfMake from "pdfmake/build/pdfMake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { takeUntil } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { Subject, Subscription } from "rxjs";
import { DataService } from "src/app/shared/Services/data.service";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: "app-chatbot",
  templateUrl: "./chatbot.component.html",
  styleUrls: ["./chatbot.component.scss"],
})
export class ChatbotComponent implements OnInit {
  interactionAllowed: boolean = false;
  @ViewChild(PerfectScrollbarComponent) scroll: PerfectScrollbarComponent;
  private destroy$: Subject<void> = new Subject<void>();

  private cancelPreviousRequests$ = new Subject<void>();

  subscriptions: Subscription[] = [];
  isRequestInProgress: boolean = false;
  formData: FormGroup;
  chatSubmit = false;
  username: string;
  selectedDeviceId:string=''
  breadCrumbItems: Array<{}>;
  chatMessagesData: any[] = [];
  custId:string ='';

  defaultQueries: string[] = [
    "Summary Latest Day", 
    'Fullday Report',
    "OEE Report Latest",
    "Enegy Report Latest",
    "Shift Analysis-Latest",
    "Compare Last 2 Days",
  ];

  analysisResult: any = null;
  user:any;
  private typingMessageIndex: number | null = null;
  deviceList:any=[];
  constructor(
    public formBuilder: FormBuilder,
    private http: HttpClient,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private dataservice: DataService,
  ) {
      this.user = JSON.parse(sessionStorage.getItem('currentUser') || '{}');
    if(this.user['role']!=='SUPERADMIN'){
      this.custId = this.user?.['user']?.['custId']
    }
  }
  ngOnInit(): void {
    this.breadCrumbItems = [
      { label: "Wimera" },
      { label: "ChatBot", active: true },
    ];
    this.formData = this.formBuilder.group({
      message: ["", [Validators.required]],
    });
    this.getDevices()
    
  }

  getDevices() {
    this.dataservice.get("api/device").subscribe((res) => {
      this.deviceList = res;
      this.selectedDeviceId = this.deviceList[0]['deviceName'];
      this.getForm()
    });
  }
  getForm(){
this.username = "Chatbot";
    setTimeout(() => {
      this.chatMessagesData.push({
        align: "centre",
        message: "Welcome to the Wimera Production Chatbot. 👋",
        animate: true, // 👈 mark as animated
      });
      this.scrollToBottom();
    }, 1000);

    setTimeout(() => {
      this.chatMessagesData.push({
        align: "centre",
        message:
          "This assistant provides you with real-time production insights.",
        animate: true, // 👈 mark as animated
      });
      this.scrollToBottom();
    }, 2000);

    const currentDate = new Date();
    setTimeout(() => {
      this.chatMessagesData.push({
        align: "right",
        message:
          "Please feel free to ask for any production-related details. 😊",
        time: this.formatTime(currentDate),
      });
      this.scrollToBottom();
      this.interactionAllowed = true;
    }, 3000);
  }

  get form() {
    return this.formData.controls;
  }

  scrollToBottom(): void {
    if (this.scroll && this.scroll.directiveRef) {
      this.scroll.directiveRef.scrollToBottom(0, 500);
    }
  }

 messageSave() {
  if (!this.interactionAllowed) {
    this.toastr.warning("Please wait for the welcome message to finish.");
    return;
  }

  if (this.isRequestInProgress) {
    this.toastr.warning("Please wait for the current request to finish.");
    return;
  }

  const message = this.formData.get("message").value;
  const currentDate = new Date();

  if (this.formData.invalid || !message) {
    this.chatSubmit = true;
    return;
  }

  this.chatSubmit = false;

  // 👉 Push user message
  this.chatMessagesData.push({
    align: "right",
    icon: "mdi mdi-account",
    name: "You",
    message,
    time: this.formatTime(currentDate),
  });

  this.formData.reset();

  // 👉 Scroll after pushing user message
  setTimeout(() => this.scrollToBottom(), 0);

  // 👉 Delay the typing indicator by 1 second
  setTimeout(() => {
    this.typingMessageIndex = this.chatMessagesData.length;
    this.chatMessagesData.push({
      align: "left",
      icon: "mdi mdi-robot",
      image: "assets/chatbot.png",
      name: this.username,
      typing: true,
      time: this.formatTime(new Date()),
    });

    // 👉 Scroll again after typing indicator is added
    setTimeout(() => this.scrollToBottom(), 0);

    // 👉 Now call the API AFTER typing is shown
    this.callChatBotAPI(message);
  }, 1000);
}


  sendDefaultQuery(query: string) {
    if (!this.interactionAllowed) {
      this.toastr.warning("Please wait for the welcome message to finish.");
      return;
    }

    this.formData.patchValue({ message: query });
    this.messageSave();
  }
//   callChatBotAPI(userMessage: any) {
//     this.isRequestInProgress = true;
//     if (this.typingMessageIndex === null) {
//       this.typingMessageIndex = this.chatMessagesData.length;
//       this.chatMessagesData.push({
//         align: "left",
//         icon: "mdi mdi-robot",
//         name: this.username,
//         message: "Typing...",
//         time: this.formatTime(new Date()),
//         typing: true,
//       });
//     }
//      let data = `${this.selectedDeviceId} - ${userMessage}`
//     const obj = {
//       custId:this.custId,
//       query: data,
//     };
// // https://k2chartbot-aghmcnhya4g0dchk.centralindia-01.azurewebsites.net/api/chat?code=myY8UMMO3ZIQVQnEd2RySH-rdiqQuj3qdxklIv_5nfH-AzFuLQCwaA==
//     const subscription = this.http
//       .post("http://192.168.1.179:5000/api/chat", obj)
//       .pipe(takeUntil(this.cancelPreviousRequests$))
//       .subscribe(
//         (res: any) => {
//           // Remove typing indicator
//           if (this.typingMessageIndex !== null) {
//             this.chatMessagesData.splice(this.typingMessageIndex, 1);
//             this.typingMessageIndex = null;
//           }

//           // Add AI response
//           this.chatMessagesData.push({
//             align: "left",
//             icon: "mdi mdi-robot",
//             name: this.username,
//             // message: res.response,
//             message: this.formatMessage(res.response),
//             time: this.formatTime(new Date()),
//           });

//           // If charts are returned, push them too
//           if (res.charts && Array.isArray(res.charts)) {
//             res.charts.forEach((chart: any) => {
//               this.chatMessagesData.push({
//                 align: "left",
//                 chart: chart,
//               });
//             });
//           }

//           this.analysisResult = res;

//           setTimeout(() => this.scrollToBottom(), 0);
//           this.isRequestInProgress = false;
//         },
//         (error) => {
//           if (this.typingMessageIndex !== null) {
//             this.chatMessagesData.splice(this.typingMessageIndex, 1);
//             this.typingMessageIndex = null;
//           }
//           // this.toastr.error("Server Unreachable", error.error);
//           this.chatMessagesData.push({
//             align: "left",
//             icon: "mdi mdi-robot",
//             name: this.username,
//             message:
//               "We’re unable to process your request at the moment. Please try again later.",
//             time: this.formatTime(new Date()),
//           });
//           this.isRequestInProgress = false;
//         }
//       );

//     this.subscriptions.push(subscription);
//   }

  callChatBotAPI(userMessage: any) {
    this.isRequestInProgress = true;
    if (this.typingMessageIndex === null) {
      this.typingMessageIndex = this.chatMessagesData.length;
      this.chatMessagesData.push({
        align: "left",
        icon: "mdi mdi-robot",
        name: this.username,
        message: "Typing...",
        time: this.formatTime(new Date()),
        typing: true,
      });
    }
     let data = `${this.selectedDeviceId} - ${userMessage}`
    const obj = {
      custId:this.custId,
      query: data,
    };
    const subscription = this.dataservice.chatbotApi( 
      'chat',
        obj
      ).subscribe(
           (res: any) => {
          if (this.typingMessageIndex !== null) {
            this.chatMessagesData.splice(this.typingMessageIndex, 1);
            this.typingMessageIndex = null;
          }

          // Add AI response
          this.chatMessagesData.push({
            align: "left",
            icon: "mdi mdi-robot",
            name: this.username,
            // message: res.response,
            message: this.formatMessage(res.response),
            time: this.formatTime(new Date()),
          });

          // If charts are returned, push them too
          if (res.charts && Array.isArray(res.charts)) {
            res.charts.forEach((chart: any) => {
              this.chatMessagesData.push({
                align: "left",
                chart: chart,
              });
            });
          }

          this.analysisResult = res;

          setTimeout(() => this.scrollToBottom(), 0);
          this.isRequestInProgress = false;
        },
        (error) => {
          if (this.typingMessageIndex !== null) {
            this.chatMessagesData.splice(this.typingMessageIndex, 1);
            this.typingMessageIndex = null;
          }
          // this.toastr.error("Server Unreachable", error.error);
          this.chatMessagesData.push({
            align: "left",
            icon: "mdi mdi-robot",
            name: this.username,
            message:
              "We’re unable to process your request at the moment. Please try again later.",
            time: this.formatTime(new Date()),
          });
          this.isRequestInProgress = false;
        }
      );
    
    this.subscriptions.push(subscription);
  }
  selectedChart: any = null;

  openExportModal(content: any, chart: any) {
    this.selectedChart = chart;
    this.modalService.open(content, { centered: true });
  }
  openExpandModal(content: any, chart: any) {
    this.selectedChart = chart;
    this.modalService.open(content, { size: "lg", centered: true });
  }

  exportChartAsPDF(chart: any) {
    const docDefinition = {
      content: [
        { text: chart.title, style: "header" },
        {
          image: chart.image ? "data:image/png;base64," + chart.image : "",
          width: 500, // Adjust width as needed
        },
        { text: chart.description, margin: [0, 10, 0, 0] },
      ],
      styles: {
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 0, 0, 10],
        },
      },
    };

    pdfMake.createPdf(docDefinition).download(`${chart.title}.pdf`);
  }

  exportChartAsPNG(chart: any) {
    // Example implementation
    const link = document.createElement("a");
    link.href = "data:image/png;base64," + chart.image;
    link.download = chart.title + ".png";
    link.click();
  }

  private formatTime(date: Date): string {
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    return `${hours}:${minutes}`;
  }
  formatMessage(message: string): string {
  if (!message) return '';

  return message
    // Convert **bold** → <b>
    .replace(/\*\*(.*?)\*\*/g, '<b>$1</b>')

    // Convert --- → horizontal line
    .replace(/---/g, '<hr>')

    // Convert bullet points (•) → <br>• ...
    .replace(/\n•/g, '<br>•')

    // Convert line breaks
    .replace(/\n/g, '<br>');
}
  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    this.destroy$.next();
    this.destroy$.complete();
  }
}
